// extracted by mini-css-extract-plugin
module.exports = {"container":"klassDetail_container__CvMjK","apply_btn_icon_arrow":"klassDetail_apply_btn_icon_arrow___inLZ","arrow":"klassDetail_arrow__A_Pyh"};